/* global bocAmchart4 */

/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} event object containing the all the data
 * @returns {void}
 */
bocAmchart4.postProcessValet = function (event) {

    try {
        return bocAmchart4.doPostProcessValet(event);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        throw (error);
    }
};

/**
 *  Produces and returns an array of data based on the valet
 *
 * @param {object} event object containing the all the data
 * @returns {void}
 */
bocAmchart4.doPostProcessValet = function (event) {
    var data = event.target.data;

    var chart = event.target.component;

    // If the data is compressed, uncompress it
    data = bocAmchart4.decodeData(data, chart);

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Running doPostProcessValet, input data:",
            data
        );
    }

    if (chart.bocSettings.args.hasOwnProperty("datacallback")) {
        if (typeof window[chart.bocSettings.args.datacallback] === "function") {
            if (bocAmchart4.debug(chart)) {
                // eslint-disable-next-line no-console
                console.groupCollapsed(chart.bocSettings.id + " running data callback "
                    + chart.bocSettings.args.datacallback);
                // eslint-disable-next-line no-console
                console.log(window[chart.bocSettings.args.datacallback].toString());
                // eslint-disable-next-line no-console
                console.groupEnd();
            }
            window[chart.bocSettings.args.datacallback](chart, data);
        } else {
            // eslint-disable-next-line no-console
            console.log(chart.bocSettings.id + " did not find data callback function "
                + chart.bocSettings.args.datacallback);
        }
    }

    var dataProcessor = new bocAmchart4.DataProcessor(chart, data, 'date');
    dataProcessor.addGraphsFromShortcode();
    dataProcessor.addGraphsFromValetSeries();
    dataProcessor.addGraphsToChart();

    var processedData = dataProcessor.getObservationsByDate();

    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (typeof window[chart.bocSettings.args.callback] === "function") {
            if (bocAmchart4.debug(chart)) {
                // eslint-disable-next-line no-console
                console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
                // eslint-disable-next-line no-console
                console.log(window[chart.bocSettings.args.callback].toString());
                // eslint-disable-next-line no-console
                console.groupEnd();
            }
            window[chart.bocSettings.args.callback](chart, processedData);
        } else {
            // eslint-disable-next-line no-console
            console.log(chart.bocSettings.id + " did not find data callback function " + chart.bocSettings.args.callback);
        }
    }

    bocAmchart4.getChartTitlesFromGroup(data, chart);
    bocAmchart4.processTitles(chart, processedData);
    bocAmchart4.processNotes(chart, processedData);

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "After doPostProcessValet, processedData:",
            processedData
        );
    }

    new bocAmchart4.InteractiveProcessor(chart, processedData);
    if (typeof chart.bocSettings.interactiveConfig !== 'undefined') {
        processedData = chart.data;
    }
    event.target.data = processedData;

    bocAmchart4.generatePrintCopy(chart);

};
